/**
 * A share code on screen. The 8 x 8 font has no lower case, and base64url needs it, so lower case
 * letters are drawn in cyan: the code can still be read off the screen and typed.
 */

import { CYAN, WHITE, YELLOW } from '../../../render/palette';
import type { Screen } from '../../../render/screen';

export const LOWER_INK = CYAN;

export function drawCode(s: Screen, text: string, x: number, y: number): void {
  let cx = x;
  for (const ch of text) {
    const ink = ch >= 'a' && ch <= 'z' ? LOWER_INK : ch >= 'A' && ch <= 'Z' ? WHITE : YELLOW;
    s.text(ch, cx, y, ink);
    cx += 8;
  }
}
